import React, { forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import Axios from "axios";
import { Modal } from "antd";
import ModalSpecial from "../../../Layout/Modals/ModalSpecial";
import OrderShowModal from "./orderShowModal";
import { getStatusesOptions } from "../../../../redux/Actions/statusesAction";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import { getCommentStateOption } from "../../../../redux/Actions/comment_StateAction";
import { addOverFlow, removeOverFlow } from "../../../../helpers/modalFunc";
import ServiceModalComponent from "../../../ServicePage/Items/ServiceForms/ServiceModalComponent";
import { useSelector } from "react-redux";
import Spinner from "../../Spinner";
import { CommentStateType } from "../../CommentState_type";
import FakeOrderShowModal from "../../../fake_orders/FakeOrderShowModal";
import { Alert } from "../../../globals";
import { AiOutlineFileSearch } from "react-icons/ai";

const RegularOrderChildren = forwardRef((props, ref) => {
  const { loading_order, error_order } = useSelector((state) => state.orders);
  const validate_comments = useSelector(
    (state) => state.orders.validate_comments
  );
  const customerBlacklisted = useSelector(
    (state) => state.orders.order?.customer?.blacklisted_at
  );
  const userRoleTitle = useSelector(
    (state) => state.auth.user?.user_role?.title
  );
  const isSuperAdmin = userRoleTitle?.toLowerCase() === "super admin";
  const [display, setDisplay] = React.useState("first");
  const [SupplySupplierData, setSupplySupplierData] = React.useState([]);
  const [CommentsState, setCommentsState] = React.useState([]);
  const [AvailableStatus, setAvailableStatus] = React.useState([]);
  const [isApiLogsModalOpen, setIsApiLogsModalOpen] = React.useState(false);
  const [apiLogsLoading, setApiLogsLoading] = React.useState(false);
  const [apiLogsError, setApiLogsError] = React.useState(null);
  const [apiLogsData, setApiLogsData] = React.useState([]);

  React.useEffect(() => {
    setIsApiLogsModalOpen(false);
    setApiLogsLoading(false);
    setApiLogsError(null);
    setApiLogsData([]);
  }, [props.requiredOrderId]);

  useImperativeHandle(ref, () => {
    return {
      openModal: (active) => open(active),
      close: () => close(),
      active: display,
    };
  });

  const open = (active) => {
    if (active !== "Service") {
      requestOfOptions();
    }
    addOverFlow();
    setDisplay(active);
  };

  const close = () => {
    removeOverFlow();
    setIsApiLogsModalOpen(false);
    setDisplay(false);
  };

  const fetchApiLoggers = async () => {
    if (!props.requiredOrderId || apiLogsLoading) {
      return;
    }

    setApiLogsLoading(true);
    setApiLogsError(null);

    try {
      const { data } = await Axios.get(
        `/api/v1/orders/${props.requiredOrderId}/api_loggers`
      );
      const payload = Array.isArray(data?.data) ? data.data : [];
      setApiLogsData(payload);
    } catch (error) {
      setApiLogsError(error?.response?.data || "Failed to load api logs");
    } finally {
      setApiLogsLoading(false);
    }
  };

  const openApiLogsModal = () => {
    setIsApiLogsModalOpen(true);
    fetchApiLoggers();
  };

  const formatApiLogDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const pad = (part) => String(part).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  const requestOfOptions = () => {
    getSuppliersOption().then((response) => {
      if (response.data) {
        let newArray = [];
        response.data.data.forEach((item) => {
          const findIndex = newArray.findIndex(
            (find) => find.name == item.name
          );
          if (findIndex == -1) {
            return newArray.push({
              value: item.id,
              name: item.name,
              code: item.code,
              label: item.title || item.name,
              is_code: item.is_code,
            });
          }
        });
        setSupplySupplierData(newArray);
      }
    });

    getCommentStateOption().then((res) => {
      if (res.data) {
        let commentAll = [];
        let comment_ka = [];
        let comment_management = [];
        let comment_logistic = [];

        res.data.forEach((item) => {
          let newObj = {
            label: item.name,
            name: item.name,
            value: item.id,
            color: item.color,
            ordering: item.ordering,
            identifier: item.identifier,
            comment_type: item.comment_type,
            show_date: item.show_date,
          };
          commentAll.push(newObj);
          let cmst = item.comment_type;
          if (cmst == "comment_ka") {
            comment_ka.push(item);
          } else if (cmst == "comment_management") {
            comment_management.push(item);
          } else {
            comment_logistic.push(item);
          }
        });
        setCommentsState(commentAll);
      }
    });

    getStatusesOptions().then((response) => {
      if (response) {
        setAvailableStatus(response);
      }
    });

    console.count("Request times; ");
  };

  if (display == "FakeOrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Fake order <span className="text-orange">#</span>
        FO{props.requiredOrderId}
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => {}}
        onClose={() => {
          close();
        }}
      >
        {loading_order ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <Spinner />
          </div>
        ) : !!error_order ? (
          <Alert message={error_order} type="error" />
        ) : (
          <FakeOrderShowModal order_id={props.requiredOrderId} />
        )}
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  } else if (display == "OrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Order <span className="text-orange">#</span>
        {props.requiredOrderId}
        {!!customerBlacklisted && (
          <span
            className="ml-3"
            style={{ fontSize: "1rem", color: "#dc3545", fontWeight: "600" }}
          >
            Blacklist client order
          </span>
        )}
      </span>
    );

    return ReactDOM.createPortal(
      <>
        <ModalSpecial
          text={tilteSpan}
          handleSave={() => {}}
          maskClosable
          headerAction={
            isSuperAdmin ? (
              <button
                type="button"
                className="initial-button d-flex align-items-center text-black"
                style={{ fontSize: "14px", fontWeight: 600 }}
                title="Order API logs"
                aria-label="Order API logs"
                onClick={openApiLogsModal}
              >
                <AiOutlineFileSearch size={20} />
                <span className="ml-1">API logs</span>
              </button>
            ) : null
          }
          onClose={() => {
            if (Object.values(validate_comments).some((d) => d)) {
              if (
                confirm(
                  `Are you sure want to close modal with unposted comments ? Unposted: ${Object.entries(
                    validate_comments
                  )
                    .filter((d) => d[1])
                    .map((d) => CommentStateType(d[0]))
                    .join(", ")}`
                )
              )
                return close();
            } else {
              close();
            }
          }}
        >
          {loading_order ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "100%" }}
            >
              <Spinner />
            </div>
          ) : !!error_order ? (
            <Alert message={error_order} type="error" />
          ) : (
            <OrderShowModal
              modal_type={props.modal_type}
              avalaibleStatus={AvailableStatus}
              supplySupplier={SupplySupplierData}
              comments_state={CommentsState}
            />
          )}
        </ModalSpecial>

        <Modal
          visible={isApiLogsModalOpen}
          title={`Order #${props.requiredOrderId} API logs`}
          onCancel={() => setIsApiLogsModalOpen(false)}
          footer={null}
          width={900}
        >
          {apiLogsLoading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "120px" }}
            >
              <Spinner />
            </div>
          ) : apiLogsError ? (
            <div className="text-danger">{String(apiLogsError)}</div>
          ) : apiLogsData.length === 0 ? (
            <div>No API logs for this order.</div>
          ) : (
            <div style={{ maxHeight: "70vh", overflow: "auto" }}>
              {apiLogsData.map((logger) => (
                <div
                  key={logger.id}
                  className="mb-3 pb-2"
                  style={{ borderBottom: "1px solid #e9ecef" }}
                >
                  <div className="d-flex justify-content-between mb-2">
                    <strong>{logger.log_item || "-"}</strong>
                    <span>{formatApiLogDate(logger.created_at)}</span>
                  </div>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      background: "#f8f9fa",
                      borderRadius: "4px",
                      padding: "8px",
                      marginBottom: 0,
                    }}
                  >
                    {logger.body || "-"}
                  </pre>
                </div>
              ))}
            </div>
          )}
        </Modal>
      </>,
      document.getElementById("modal-roots")
    );
  } else if (display == "ServiceShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        <span className="text-black">RMA</span>{" "}
        <span className="text-orange">#</span>
        <span className="text-black">R{+props.requiredOrderId + 100}</span>
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => {}}
        onClose={() => close()}
      >
        <ServiceModalComponent id={props.requiredOrderId} />
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  }

  return null;
});

export default RegularOrderChildren;
